import styled from "styled-components";
import { Description, Flex, IconButtonButton, InputsGroup as InputsGroupUI } from "@evergis/ui";

import { LEFT_PANEL_MIN_WIDTH } from "../Layout/constants";
import { ClassificationBlank } from "../Classification/styled";
import { ScrollableContainer } from "../../modules/Style/styled";

export const SymbolSettingsContainer = styled.div`
  width: ${LEFT_PANEL_MIN_WIDTH - 48}px;
  padding: 1.5rem 0.75rem 1.5rem 1.5rem;
`;

export const SymbolEditorRow = styled.div`
  display: flex;
  flex-direction: row;

  > *:not(:first-child) {
    margin-left: 1rem;
  }
`;

export const ColorContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ClassificationColorContainer = styled(ColorContainer)<{ ableClassify?: boolean }>`
  width: ${({ ableClassify }) => (ableClassify ? 4 : 2)}rem;
  background-color: ${({ theme: { palette } }) => palette.background};
`;

export const EditorContainer = styled.span`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0.5rem;
`;

export const RefContainer = styled.span`
  position: absolute;
  width: 100%;
  height: 100%;
  visibility: hidden;
  left: 0;
  top: 0;
`;

export const InputsGroup = styled(InputsGroupUI)<{ mini?: boolean }>`
  margin: ${({ mini }) => (mini ? "0 0 0.8rem 0" : "0.5rem 0")};
`;

export const ClassifierWithError = styled(Flex)`
  flex-direction: row;
  flex-wrap: nowrap;
`;

export const ClassifierError = styled(Description)`
  flex-grow: 1;
  align-self: flex-end;
  margin: 0 0 1.1rem 0.5rem;
  color: ${({ theme: { palette } }) => palette.error};
`;

export const ExtendedAttrAggrListContainer = styled.div`
  height: 100%;
  background-color: ${({ theme: { palette } }) => palette.elementDark};
`;

export const ExtendedAttrAggrItemContainer = styled.div`
  ${ClassificationBlank} {
    align-items: center;
    padding: 1rem;
  }

  ${IconButtonButton} {
    margin-right: -0.5rem;
  }
`;

export const ExtendedAttrAggrRow = styled.div`
  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`;

export const ExtendedAttrAggrListWrapper = styled(ScrollableContainer)`
  max-height: calc(100vh - 10.625rem);
  padding: 1rem 1.5rem;
`;

export const ExtendedAttrAggrToolbar = styled(Flex)`
  align-items: center;
  height: 3.125rem;
  margin-left: 1.5rem;
`;

export const ExtendedAttrAggrSeparator = styled.div`
  height: 1rem;
  margin: 0 0.5rem 0 1rem;
  border-left: 1px ${({ theme: { palette } }) => palette.elementDeep} solid;
`;
